// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-formula-FormulaTemplateInput-FormulaTemplateInput2-module__dropdown--PZMOR {
  overflow: auto;
  max-height: 70vh;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ManagementPage/Obj2Tab/forms/AttrForm2/MetaInfo/formula/FormulaTemplateInput/FormulaTemplateInput2.module.less"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;AACF","sourcesContent":[".dropdown {\n  overflow: auto;\n  max-height: 70vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-formula-FormulaTemplateInput-FormulaTemplateInput2-module__dropdown--PZMOR`
};
export default ___CSS_LOADER_EXPORT___;
